import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as selectors from './selectors';
import { apiUrl } from '../config'
import { getHeaderJwtJson } from "helpers/FetchHelper";
import { IDocumentGet } from "features/documents/types/types";
import { ITableModel } from "helpers/types/types";
import { putDocuments } from 'features/documents/documentsSlice';
import { selectCategory } from 'features/treeCategory/categorySlice';

function* workerSelect() {
  const data: ITableModel<IDocumentGet> | undefined = yield call(fetchDocuments);
  if (data !== undefined)
    yield put(putDocuments(data));
}

function* fetchDocuments(): Generator<any, ITableModel<IDocumentGet> | undefined, any> {
  const id = yield select(selectors.id)
  if (id && id !== 'root') {
    const url = apiUrl + "documents/list/";
    const responce = yield fetch(url + id, { headers: getHeaderJwtJson() });
    const data: ITableModel<IDocumentGet> | undefined = yield responce.json();
    return data;
  }
  return { items: [], totalCount: 0 } as ITableModel<IDocumentGet>;
}

export function* watchSelect() {
  yield takeEvery(selectCategory.type, workerSelect);
}


